import React from "react"
import "./ErrorBoundary.css"
import { logClientErrorToStorage } from "../../utils/errorLogger"

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(_error) {
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        console.error("Error capturado:", error, errorInfo)
        // Intentar enviar el log a Storage (no bloquear la UI)
        try {
            logClientErrorToStorage(error, errorInfo, {
                source: "ErrorBoundary",
            }).catch(() => {})
        } catch (_) {
            // Ignorar errores del logger
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-boundary-container">
                    <div className="error-boundary-content">
                        <h1 className="error-boundary-title">¡Ups! Algo salió mal</h1>
                        <p className="error-boundary-message">
                            Lo sentimos, ha ocurrido un error inesperado. Nuestro equipo ha sido notificado y estamos trabajando para
                            solucionarlo.
                        </p>
                        <button onClick={() => window.location.reload()} className="error-boundary-button">
                            Recargar la página
                        </button>
                    </div>
                </div>
            )
        }

        return this.props.children
    }
}

export default ErrorBoundary
